import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as selectors from './Layout.selectors';
import * as actions from './Layout.actions';
import * as loginActions from './../Login/Login.actions';
import * as loginSelectors from './../Login/Login.selectors';
import './Layout.scss';
import Favicon from 'react-favicon';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import HelpModal from './HelpModal';
import TermOfUseModal from './TermOfUseModal';
import { Helmet } from 'react-helmet';
import * as dialog from './../common/dialog';

class PqtLayout extends Component {
    componentDidMount() {
        this.props.fetchHelpRequestOpenTickets();
    }

    render() {
        if (this.props.user == null) {
            this.props.logout(this.props.history);
            return null;
        }

        const logoutHandler = event => {
            event.preventDefault();
            this.props.logout(this.props.history);
        }

        const renderDot = (step) => {
            if (this.props.step > step || (step === 6 && this.props.step === step)) {
                return <i className="fas fa-check-circle" />;
            }
            return <i className="fas fa-dot-circle" />;
        };

        const getDotClasses = (step) => {
            if (this.props.step > step || (step === 6 && this.props.step === step)) {
                return ['number', 'finished'].join(' ');
            }
            if (this.props.step === step) {
                return ['number', 'active'].join(' ');
            }
            return 'number';
        };

        const getJoinClasses = (step) => {
            if (this.props.step >= step) {
                return ['join-line', 'finished'].join(' ');
            }
            return 'join-line';
        };

        let stepsContainer = null;
        let className = 'content no-steps';
        if (this.props.step) {
            className = 'content';

            let comingFromCoupa = null;
            if (this.props.cxmlData.buyer_cookie != null) {
                comingFromCoupa = <div className="coming-from-coupa">You are coming through COUPA</div>;
            }

            stepsContainer = (
                <div className="steps-container">
                    {comingFromCoupa}
                    <div className="step welcome">
                        <div className="title">1. Welcome</div>
                        <div className={getDotClasses(1)}>{renderDot(1)}</div>
                    </div>
                    <div className="step data">
                        <div className="title">2. Product</div>
                        <div className={getDotClasses(2)}>{renderDot(2)}</div>
                        <div className={getJoinClasses(2)}></div>
                    </div>
                    <div className="step preview">
                        <div className="title">3. Variables/Preview</div>
                        <div className={getDotClasses(3)}>{renderDot(3)}</div>
                        <div className={getJoinClasses(3)}></div>
                    </div>
                    <div className="step order">
                        <div className="title">4. Shopping Cart</div>
                        <div className={getDotClasses(4)}>{renderDot(4)}</div>
                        <div className={getJoinClasses(4)}></div>
                    </div>
                    <div className="step order">
                        <div className="title">5. Checkout</div>
                        <div className={getDotClasses(5)}>{renderDot(5)}</div>
                        <div className={getJoinClasses(5)}></div>
                    </div>
                    <div className="step done">
                        <div className="title">6. Done!</div>
                        <div className={getDotClasses(6)}>{renderDot(6)}</div>
                        <div className={getJoinClasses(6)}></div>
                    </div>
                </div>
            )
        }

        return (
            <div className="layout-container">
                <Favicon url="https://ac-ut-health.s3.amazonaws.com/favicon.ico" />
                <Helmet>
                    <title>UT Physicians</title>
                </Helmet>
                <div className="sidebar">
                    <Sidebar
                        user={this.props.user}
                        openTickets={this.props.openTickets}
                        cxmlData={this.props.cxmlData}
                        platformType={this.props.platformType}
                        history={this.props.history}
                        clearPlatformType={this.props.clearPlatformType}
                    />
                </div>
                <div className="content-area">
                    <Header
                        user={this.props.user}
                        cxmlData={this.props.cxmlData}
                        logoutHandler={logoutHandler}
                        title={this.props.title}
                        actionButton={this.props.actionButton}
                        history={this.props.history}
                        clearPlatformType={this.props.clearPlatformType}
                        showHelpModal={this.props.showHelpModal}
                    />
                    <div className="content-container">
                        {stepsContainer}
                        <div className={className}>
                            {this.props.children}
                        </div>
                    </div>
                    <Footer
                        showTermOfUseModal={this.props.showTermOfUseModal}
                    />
                </div>
                <HelpModal
                    fields={this.props.fields}
                    isSending={this.props.isSending}
                    hideHelpModal={this.props.hideHelpModal}
                    sendRequest={this.props.sendRequest}
                    setField={this.props.setField}
                    addFile={this.props.addFile}
                    removeFile={this.props.removeFile}
                    clearFiles={this.props.clearFiles}
                    resetFields={this.props.resetFields}
                    files={this.props.files}
                    fittingMonth={this.props.fittingMonth}
                    fittingDate={this.props.fittingDate}
                    setFittingMonth={this.props.setFittingMonth}
                    setFittingDate={this.props.setFittingDate}
                    checkingFitting={this.props.checkingFitting}
                    fittingReserved={this.props.fittingReserved}
                    checkFittingMonth={this.props.checkFittingMonth}
                />
                <TermOfUseModal
                    hideTermOfUseModal={this.props.hideTermOfUseModal}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    fields: selectors.getFields(state),
    isSending: selectors.getIsSending(state),
    openTickets: selectors.getOpenTickets(state),
    files: selectors.getFiles(state),
    fittingMonth: selectors.getFittingMonth(state),
    fittingDate: selectors.getFittingDate(state),
    fittingReserved: selectors.getFittingReserved(state),
    checkingFitting: selectors.getCheckingFitting(state),
    isAuthenticated: loginSelectors.getIsAuthenticated(state),
    user: loginSelectors.getUser(state),
    cxmlData: loginSelectors.getCxmlData(state),
    platformType: loginSelectors.getPlatformType(state),
    loginType: loginSelectors.getLoginType(state),
});

const mapDispatchToProps = (dispatch) => ({
    sendRequest: () => dispatch(actions.sendRequest()),
    setField: (field, value) => dispatch(actions.setField(field, value)),
    fetchHelpRequestOpenTickets: () => dispatch(actions.fetchHelpRequestOpenTickets()),
    addFile: (file) => dispatch(actions.addFile(file)),
    removeFile: (index) => dispatch(actions.removeFile(index)),
    clearFiles: (index) => dispatch(actions.clearFiles(index)),
    resetFields: () => dispatch(actions.resetFields()),
    setFittingMonth: (value) => dispatch(actions.setFittingMonth(value)),
    setFittingDate: (value) => dispatch(actions.setFittingDate(value)),
    checkFittingMonth: () => dispatch(actions.checkFittingMonth()),
    logout: (history) => dispatch(loginActions.logout(history)),
    clearPlatformType: () => dispatch(loginActions.clearPlatformType()),
    showHelpModal: () => dispatch(dialog.actions.showDialog('help-modal')),
    hideHelpModal: () => dispatch(dialog.actions.hideDialog('help-modal')),
    showTermOfUseModal: () => dispatch(dialog.actions.showDialog('term-of-use-modal')),
    hideTermOfUseModal: () => dispatch(dialog.actions.hideDialog('term-of-use-modal')),
});

export default connect(mapStateToProps, mapDispatchToProps)(PqtLayout);
